const messages = require('./libs/messages');
module.exports = {
  messages
};
